import { Stack, useRouter } from "expo-router";
import { useEffect, useState, type ReactNode } from "react";
import { ActivityIndicator, View } from "react-native";

import { useAuth } from "./authContext";
import { getMyJudgeAssignments } from "./judges";

export function JudgePortalGate({ children }: { children?: ReactNode }) {
  const { user, loading } = useAuth();
  const router = useRouter();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (loading) return;
    if (!user) {
      router.replace("/login");
      return;
    }
    void (async () => {
      const rows = await getMyJudgeAssignments();
      if (!mounted) return;
      const ok = rows.length > 0;
      setAllowed(ok);
      setChecking(false);
      if (!ok) router.replace("/login");
    })();
    return () => {
      mounted = false;
    };
  }, [loading, user, router]);

  if (loading || checking || !allowed) {
    return (
      <View className="flex-1 items-center justify-center bg-bg">
        <ActivityIndicator size="large" color="#0A2540" />
      </View>
    );
  }

  return children ?? <Stack screenOptions={{ headerShown: false }} />;
}
